import React, { useEffect, useRef, Suspense, useMemo } from "react";
import { Canvas, extend, useThree, useLoader, useFrame } from '@react-three/fiber'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { Center, Float, Text3D,GradientTexture, } from "@react-three/drei";
extend({ TextGeometry, OrbitControls })


export default function TextCover(props) {

    return (
        <Canvas
            // frameloop='demand'
            gl2={true}
            gl={{ antialias: true, alpha: false }}
            onCreated={({ gl }) => {
                gl.setPixelRatio(window.devicePixelRatio);
                gl.domElement.style.borderTopLeftRadius = '5px'
                gl.domElement.style.borderTopRightRadius = '5px'
            }}
        >
            <ambientLight intensity={0.5} />
            <color attach="background" args={['white']} />
            <Scene
                {...props}
            />
        </Canvas>

    )
}


function Scene({position =[0,0,0],...props}) {
    const { camera, gl, invalidate, scene } = useThree()
    const orbit = useRef()




    // useEffect(() => {
    //     if (orbit.current) {
    //         orbit.current.enableDamping = true
    //         // orbit.current.enableDamping = true
    //         orbit.current.addEventListener('start', handleOrbitStart);
    //         orbit.current.addEventListener('changed', handleOrbitEnd);
    //         orbit.current.addEventListener('change', handleOrbitChange);
    //         return () => {
    //             if (orbit.current) {
    //                 orbit.current.removeEventListener('start', handleOrbitStart);
    //                 orbit.current.removeEventListener('changed', handleOrbitEnd);
    //                 orbit.current.removeEventListener('change', handleOrbitChange);
    //             }
    //         };
    //     }
    // }, [orbit.current])

    // const handleOrbitChange = () => {
    //     invalidate()
    // }
    // const handleOrbitStart = () => {
    //     invalidate()
    // }
    // const handleOrbitEnd = () => {
    //     invalidate()
    // }

    return (
        <>
            <Suspense fallback={null
            }>
                {/* <mesh position={[0, 0, 0]} >
                    <textGeometry attach='geometry' args={['2321312', config]} />
                    <meshBasicMaterial attach='material' color={'red'} />
                </mesh> */}
                <Center>
                    <Float floatIntensity={5} speed={2}>
                        <Text3D font={'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/fonts/helvetiker_bold.typeface.json'} bevelSize={0.05} position={position}>
                            {props.name}
                            <meshBasicMaterial>
                                <GradientTexture
                                    stops={[0, 1]} // As many stops as you want
                                    colors={props.color} // Colors need to match the number of stops
                                    size={1024} // Size is optional, default = 1024
                                />
                            </meshBasicMaterial>
                        </Text3D>
                    </Float>

                </Center>

            </Suspense>
            <orbitControls ref={orbit} args={[camera, gl.domElement]} />
        </>
    )
}


